import { DOCUMENT_ROOT_PATH } from '@/helpers/documentFolders'

export function titleFromFileName(fileName) {
  const name = String(fileName || '').trim()
  const dot = name.lastIndexOf('.')
  if (dot <= 0) return name
  return name.slice(0, dot)
}

export function buildDocumentDownloadUrl(relativePath) {
  const path = String(relativePath || '').trim()
  if (!path) return ''
  const parts = path.split('/').filter(Boolean)
  if (!parts.length) return ''
  const fileName = parts[parts.length - 1]
  const parentParts = parts.slice(0, -1)
  const currentPath = parentParts.length
    ? `${DOCUMENT_ROOT_PATH}/${parentParts.join('/')}`
    : DOCUMENT_ROOT_PATH
  const params = new URLSearchParams({
    fileName,
    currentPath,
  })
  return `/api/1/download?${params.toString()}`
}

export function resolveDocumentFile(file) {
  if (!file || typeof file !== 'object') return null
  const path = String(file.path || '').trim()
  const legacyUrl = String(file.url || '').trim()
  const url = path ? buildDocumentDownloadUrl(path) : legacyUrl
  if (!url) return null
  const title = String(file.title || '').trim()
    || (path ? titleFromFileName(path.split('/').pop()) : '')
  return {
    title: title || 'Документ',
    format: String(file.format || 'PDF').trim() || 'PDF',
    size: String(file.size || '').trim(),
    url,
  }
}
